import { Checkbox as CheckboxBase } from './Checkbox'
import { CheckboxOption } from './CheckboxOption'

export type { CheckboxOptionProps, CheckboxProps } from './types'

export const Checkbox = Object.assign(CheckboxBase, {
  Option: CheckboxOption,
})
